<template>
  <div>
    <div class="row text-center" v-if="!dataLoaded">
       <div class="col">
         <span
             class="spinner-border"
             role="status"
         >
          <span class="sr-only">Loading...</span>
      </span>
       </div>
    </div>

    <div v-else>
      <div class="row" v-if="isAbleToStartHourly">
        <div class="col">
          <task-item
              v-for="task in hourlyTasks"
              :task="task"
              :key="`hourly-${task.completed_at}`"
              :placeholder="genHourlyTaskPlaceholder(task.completed_at, timezone)"
              :isPersonal="true"
              :labelOptions="labelOptions"
              @taskUpdated="updateTaskList"
              @taskDeleted="deleteFromTaskList"
              @saveLabel="saveLabel"
              @deleteLabel="deleteLabel"
          ></task-item>
        </div>
      </div>

      <div class="text-center" v-else>
        <p>Please check-out and check-in again</p>
      </div>
    </div>
  </div>
</template>

<script>
import genHourlyTaskPlaceholder from '../../../utils/task/genHourlyTaskPlaceholder';
import Task from '../Task';
import moment from 'moment';

export default {
  name: 'HourlyTaskList',

  props: ['yourHourlyTasks'],

  data () {
    return {
      hourlyTasks: this.yourHourlyTasks ?? [],
      taskService: Task,
      dataLoaded: !!this.yourHourlyTasks,
    };
  },

  computed: {
    timezone () {
      return this.$store.state.timezone;
    },

    labelOptions () {
      return this.$store.state.labelOptions;
    },

    isAbleToStartHourly() {
      return this.hourlyTasks.length > 0;
    },
  },

  methods: {
    genHourlyTaskPlaceholder: genHourlyTaskPlaceholder,

    async fetchHourlyTasks () {
      let hourlyTasks = await this.taskService.fetchHourlyTasks();

      if (!hourlyTasks) {
        this.dataLoaded = true;
        return;
      }

      let tasksWithSubtasks = [];

      hourlyTasks.forEach((item) => {
        if (item.id && item.total_subtasks > 0) {
          tasksWithSubtasks.push(item.id);
        }
      });

      if (tasksWithSubtasks.length > 0) {
        const res = await axios.get('/task/subtasks', {
          params: {
            ids: tasksWithSubtasks.join(','),
          },
        });
        const subtasks = res.data.data;

        hourlyTasks = hourlyTasks.map((item) => {
          const subtask = subtasks[item.id];

          if (!!subtask) {
            item['subtasks'] = subtask;
          }

          return item;
        });
      }

      this.hourlyTasks = hourlyTasks;
      this.dataLoaded = true;
      this.$emit('storeTasksLocally', {
        key: 'yourHourlyTasks',
        tasks: hourlyTasks,
      });
    },

    updateTaskList (updatedTask) {
      this.hourlyTasks = this.hourlyTasks.map(task => {
        const dateIsSame = moment(task.completed_at).isSame(moment(updatedTask.completed_at));

        if (task.id === updatedTask.id || dateIsSame) {
          task = updatedTask;
        }

        return task;
      });

      this.$emit('storeTasksLocally', {
        key: 'yourHourlyTasks',
        tasks: this.hourlyTasks,
      });
    },

    deleteFromTaskList (deletedTask) {
      this.hourlyTasks = this.hourlyTasks.map(task => {
        if (task.id === deletedTask.id) {
          task = {
            title: '',
            type: 'hourly',
            completed_at: task.completed_at,
          };
        }

        return task;
      });

      this.$emit('storeTasksLocally', {
        key: 'yourHourlyTasks',
        tasks: this.hourlyTasks,
      });
    },

    async saveLabel (data) {
      let isNewLabel = true;
      const { label } = data;

      this.$store.state.labelOptions = this.labelOptions.map((value) => {
        if (label.id === value.id) {
          isNewLabel = false;
          return label;
        }

        return value;
      });

      if (isNewLabel) {
        this.$store.state.labelOptions.push(label);
      }
    },

    deleteLabel (labelId) {
      this.$store.state.labelOptions = this.labelOptions.filter((value) => {
        return value.id !== labelId;
      });
    },
  },

  mounted () {
    if (!this.yourHourlyTasks) {
      this.fetchHourlyTasks();
    }
  },
};
</script>

<style scoped>

</style>
